export default "__VITE_ASSET__BYz8wX_5__"